import type {PermissionType} from '@hconnect/apiclient'
import {useUpmPlant} from '@hconnect/upm'
import {useMemo} from 'react'

import {useUrlParam} from '../../routing'
import {checkMultiplePermissions} from '../helpers/checkMultiplePermissions'
import {checkPermissionAccessByDataScope} from '../helpers/checkPermissionAccessByDataScope'

import {usePermissionsQuery} from './queries'

/*
 * generic hook to check permissions by type
 */

export const usePermission = (...types: PermissionType[]) => {
  const plantCode = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId: plantCode, shouldRaiseError: false})

  const {data: permissions} = usePermissionsQuery(types)

  return useMemo(() => {
    if (!permissions || !upmPlant) return false

    return checkMultiplePermissions({
      requiredPermissionTypes: types,
      permissions,
      testFn: (permission) =>
        checkPermissionAccessByDataScope(upmPlant.country, plantCode, permission.parsedDataScope)
    })
  }, [permissions, upmPlant, types, plantCode])
}
